<div class="flex flex-col gap-4">

  <div class="flex gap-4">
    <div class="w-3/4">
      <elcia-text-input [control]="control().controls.street" [label]="'address.street' | translate"/>
    </div>
    <div class="w-1/4">
      <elcia-text-input [control]="control().controls.number" [label]="'address.number' | translate"/>
    </div>
  </div>

  <div class="flex gap-4">

    <div class="w-1/3">
      <elcia-text-input [control]="control().controls.city" [label]="'address.city' | translate"/>
    </div>

    <div class="w-1/3">
      <elcia-text-input [control]="control().controls.postalCode" [label]="'address.postalCode' | translate"/>

    </div>

    <div class="w-1/3">
      <elcia-country-dropdown [control]="control().controls.countryIsoCode"/>
    </div>

  </div>

</div>
